<kpd-prevent-browser-close [prevent]="form.dirty"></kpd-prevent-browser-close>
<app-change-password-dialog key="changePassword"></app-change-password-dialog>
<div class="detail__grid">
  <div class="detail__alert">
    <kpd-alert type="warning" *ngIf="upnConflict" icon="warning-standard">
      {{ upnConflict?.message }}
      <a *ngIf="upnConflict?.otherTenant" (click)="linkUserToTenant(upnConflict?.upn)" translate
        >Click here to link this user to this tenant</a
      >
      <a *ngIf="!upnConflict?.otherTenant" (click)="navigateToUser(upnConflict?.upn)" translate
        >Click here to go to this user</a
      >
    </kpd-alert>
    <kpd-alert type="error" *ngIf="errorMessage" icon="error-standard">
      {{ errorMessage }}
    </kpd-alert>
    <kpd-alert type="warning" *ngIf="concurrencyErrorMessage" icon="warning-standard">
      {{ concurrencyErrorMessage }}
      <a (click)="reloadEntity(item)">{{ reloadMessage }}</a>
    </kpd-alert>
    <kpd-alert type="warning" *ngIf="warningMessage" icon="warning-standard">
      {{ warningMessage }}
    </kpd-alert>
  </div>

  <div class="detail__toolbar">
    <kpd-action-bar>
      <ng-container *ngIf="!hideCreate">
        <kpd-action-create
          (action)="onAdd()"
          [disable]="item.isNew()"
          [title]="'Add local user' | translate"
          *kpdPermission="Permissions.UserCreate"
        >
        </kpd-action-create>
      </ng-container>

      <kpd-action-edit-toggle
        *ngIf="isLoggedInUser()"
        [readMode]="!readOnlyMode"
        (action)="toggleReadOnly()"
        [disable]="
          form.dirty || item.isNew() || !item.isDefaultTenant || (isSystemUser && !hasSystemUserManagePermission)
        "
        [readMode]="false"
      ></kpd-action-edit-toggle>
      <ng-container *ngIf="!isLoggedInUser()">
        <kpd-action-edit-toggle
          [readMode]="!readOnlyMode"
          (action)="toggleReadOnly()"
          [disable]="
            form.dirty || item.isNew() || !item.isDefaultTenant || (isSystemUser && !hasSystemUserManagePermission)
          "
          *kpdPermission="Permissions.UserUpdate"
          [readMode]="false"
        ></kpd-action-edit-toggle>
      </ng-container>

      <ng-container *ngIf="!readOnlyMode">
        <kpd-action-save (action)="onSave(form)" [disable]="!form.dirty"></kpd-action-save>
        <kpd-action-undo (action)="onRevert()" [disable]="!form.dirty"></kpd-action-undo>
      </ng-container>
      <ng-container *ngIf="!hideDelete && !isSystemUser">
        <kpd-action-delete
          (action)="onDelete(item)"
          *kpdPermission="Permissions.UserDelete"
          [disable]="item.isNew()"
        ></kpd-action-delete>
      </ng-container>
    </kpd-action-bar>
  </div>

  <div class="detail__main">
    <form
      [formGroup]="form"
      kpdPreventEnterSubmit
      novalidate
      (kpdFocusChange)="onFocusChanged($event)"
      [ngClass]="{ update: !item.isNew(), 'form--edit-mode': !item.isNew(), create: item.isNew() }"
    >
      <kpd-collapse-panel title="{{ 'General' | translate }}" [collapsed]="false">
        <div class="flex-row flex-wrap">
          <div class="flex-column form__column">
            <div class="form__control flex-row">
              <label>{{ 'Upn' | translate }}:</label>
              <div class="form__input">
                <kpd-text-input
                  [readOnly]="
                    !canEditMode ||
                    readOnlyMode ||
                    !item.isNew() ||
                    (!item.isNew() && !item.isLocal()) ||
                    (isSystemUser && !hasSystemUserManagePermission)
                  "
                  formControlName="upn"
                  [name]="'upn'"
                ></kpd-text-input>
              </div>
            </div>

            <div class="form__control flex-row">
              <label>{{ 'First name' | translate }}:</label>
              <div class="form__input">
                <kpd-text-input
                  [readOnly]="
                    readOnlyMode ||
                    !canEditMode ||
                    (!item.isNew() && !item.isLocal()) ||
                    (isSystemUser && !hasSystemUserManagePermission)
                  "
                  formControlName="firstName"
                  [name]="'firstName'"
                ></kpd-text-input>
              </div>
            </div>

            <div class="form__control flex-row">
              <label>{{ 'Last name' | translate }}:</label>
              <div class="form__input">
                <kpd-text-input
                  [readOnly]="
                    readOnlyMode ||
                    !canEditMode ||
                    (!item.isNew() && !item.isLocal()) ||
                    (isSystemUser && !hasSystemUserManagePermission)
                  "
                  formControlName="lastName"
                  [name]="'lastName'"
                ></kpd-text-input>
              </div>
            </div>

            <div class="form__control flex-row">
              <label>{{ 'Name' | translate }}:</label>
              <div class="form__input">
                <kpd-text-input
                  [readOnly]="
                    readOnlyMode ||
                    !canEditMode ||
                    form.get('firstName')?.value ||
                    form.get('lastName')?.value ||
                    (!item.isNew() && !item.isLocal()) ||
                    (isSystemUser && !hasSystemUserManagePermission)
                  "
                  formControlName="displayName"
                  [name]="'displayName'"
                ></kpd-text-input>
              </div>
            </div>

            <div class="form__control flex-row">
              <label>{{ 'Email' | translate }}:</label>
              <div class="form__input">
                <kpd-text-input
                  [readOnly]="
                    readOnlyMode ||
                    !canEditMode ||
                    (!item.isNew() && !item.isLocal()) ||
                    (isSystemUser && !hasSystemUserManagePermission)
                  "
                  formControlName="email"
                  [name]="'email'"
                ></kpd-text-input>
              </div>
            </div>

            <div class="form__control flex-row">
              <label>{{ 'Phone' | translate }}:</label>
              <div class="form__input">
                <input
                  *ngIf="
                    !readOnlyMode &&
                    canEditMode &&
                    (item.isNew() || item.isLocal()) &&
                    (!isSystemUser || hasSystemUserManagePermission)
                  "
                  formControlName="phone"
                  type="text"
                  [textMask]="{ mask: phoneMask }"
                  [ngClass]="{ 'form__input--invalid': form.controls['phone'].touched && hasError('phone') }"
                />
                <label *ngIf="readOnlyMode || !canEditMode || (!item.isNew() && !item.isLocal())" class="value">{{
                  item.phone || '&mdash;'
                }}</label>
                <div class="form__dirtyfix"></div>
                <kpd-input-error [control]="form.controls['phone']"></kpd-input-error>
              </div>
            </div>

            <div class="form__control flex-row">
              <label>{{ 'Language' | translate }}:</label>
              <div class="form__input">
                <kpd-data-lookup
                  formControlName="culture"
                  [items]="cultures"
                  [title]="'Culture' | translate"
                  [readOnly]="readOnlyMode || canEditMode !== true || (isSystemUser && !hasSystemUserManagePermission)"
                  displayField="display"
                  searchField="display"
                  valueField="name"
                  [name]="'culture'"
                  [enableSearch]="false"
                  [enableAdd]="false"
                  [columns]="languageColumns"
                >
                </kpd-data-lookup>
              </div>
            </div>
          </div>

          <div class="flex-column form__column">
            <div
              class="form__control flex-row"
              *ngIf="!readOnlyMode && item.isNew() && this.allowedUserTypes.length > 1"
            >
              <label>{{ 'Type' | translate }}:</label>
              <div class="form__input">
                <ng-container *ngFor="let type of allowedUserTypes">
                  <input
                    type="radio"
                    [(ngModel)]="userType"
                    [value]="type"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onUserTypeToggled()"
                    [disabled]="isSystemUser"
                  />{{ type.name }}
                  <br />
                </ng-container>
              </div>
            </div>

            <div class="form__control flex-row" *ngIf="!item.isNew()">
              <label>{{ 'Type' | translate }}:</label>
              <div class="form__input">
                <span *ngFor="let provider of getAuthProviders(item)" class="value">
                  {{ provider }}
                  <br />
                </span>
              </div>
            </div>

            <div
              class="form__control flex-row"
              *ngIf="!readOnlyMode && canEditMode && item.isNew() && userType && userType.passwordNeeded"
            >
              <label>{{ 'Password' | translate }}:</label>
              <div class="form__input">
                <input
                  type="password"
                  formControlName="password"
                  [ngClass]="{ 'form__input--invalid': form.controls['password'].touched && hasError('password') }"
                />
                <div class="form__dirtyfix"></div>
                <kpd-input-error [control]="form.controls['password']"></kpd-input-error>
              </div>
            </div>

            <div
              class="form__control flex-row"
              *ngIf="!readOnlyMode && canEditMode && item.isNew() && userType && userType.passwordNeeded"
            >
              <label>{{ 'Confirm password' | translate }}:</label>
              <div class="form__input">
                <input
                  type="password"
                  formControlName="confirmPassword"
                  [ngClass]="{
                    'form__input--invalid': form.controls['confirmPassword'].touched && hasError('confirmPassword')
                  }"
                />
                <div class="form__dirtyfix"></div>
                <kpd-input-error [control]="form.controls['confirmPassword']"></kpd-input-error>
              </div>
            </div>

            <div class="form__control flex-row" *ngIf="!item.isNew() && item.isLocal()">
              <label>{{ 'Password' | translate }}:</label>
              <div class="form__input">
                ●●●●●●●●
                <a (click)="changePassword()" *ngIf="hasUserManagePermission || isLoggedInUser()" translate>
                  Change password</a
                >
              </div>
            </div>

            <div class="form__control flex-row" *kpdPermission="Permissions.SystemUserManage">
              <label>{{ 'System User' | translate }}:</label>
              <div class="form__input">
                <kpd-toggle
                  [readOnly]="readOnlyMode || !item.isNew()"
                  formControlName="isSystemUser"
                  (change)="onSystemUserChanged()"
                ></kpd-toggle>
              </div>
            </div>
            <div class="form__control flex-row" *ngIf="hasUserManagePermission && item.isLockedOut">
              <label>{{ 'Locked User' | translate }}:</label>
              <div class="form__input">
                <a (click)="unlockUser()" translate> Click here to unlock user</a>
              </div>
            </div>
          </div>
        </div>
      </kpd-collapse-panel>
    </form>
  </div>
</div>
